import { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import TopLanguageBar from "@/components/feature/TopLanguageBar";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageTransition from "@/components/feature/PageTransition";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthProvider } from "@/contexts/AuthContext";
import "@/i18n/index";

function LayoutWrapper({
  currentLang,
  onLangChange,
}: {
  currentLang: string;
  onLangChange: (c: string) => void;
}) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  if (isAdmin) {
    return (
      <PageTransition>
        <AppRoutes />
      </PageTransition>
    );
  }

  return (
    <div className="flex flex-col min-h-screen">
      <div className="sticky top-0 z-50">
        <TopLanguageBar currentLang={currentLang} onLangChange={onLangChange} />
      </div>
      <Navbar />
      <div className="flex-1">
        <PageTransition>
          <AppRoutes />
        </PageTransition>
      </div>
      <Footer />
    </div>
  );
}

export default function App() {
  const [currentLang, setCurrentLang] = useState("en");
  const { i18n } = useTranslation();

  const handleLangChange = (code: string) => {
    setCurrentLang(code);
    i18n.changeLanguage(code);
    const rtlLanguages = ["ps", "da"];
    document.documentElement.dir = rtlLanguages.includes(code) ? "rtl" : "ltr";
    document.documentElement.lang = code === "da" ? "prs" : code;
  };

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <LayoutWrapper currentLang={currentLang} onLangChange={handleLangChange} />
      </AuthProvider>
    </BrowserRouter>
  );
}
